import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function pyppoi() {
  const tabs = [
    { title: 'PYP POI 2026-27', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'> Primary Programme of Inquiry 2026-2027</h1>
    </div>

     <div className='print-booklist' style={{ textAlign: "left" }}>
        <Link  to="../pdf/pyp-poi/POI 26-27.pdf"
            target="_blank"
            rel="noopener noreferrer"
        > View </Link>
       </div>



    </div> },
    { title: 'PYP POI 2025-26', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'> Primary Programme of Inquiry 2025-2026</h1>
    </div>

     <div className='print-booklist' style={{ textAlign: "left" }}>
        <Link  to="../pdf/pyp-poi/POI 25-26.pdf"
            target="_blank"
            rel="noopener noreferrer"
        > View </Link>
       </div>



    </div> },
//  

  ];
  return (
    <div>
      <div className='ibdp-hero-sec'>
        <img src='../newimg/pyppoi1.webp'/>

      </div>
    <div className='ib-syllabus'>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default pyppoi
